module.exports = __webpack_public_path__ + "static/media/inside-front.6ed99084.jpg";